module.exports = __webpack_public_path__ + "static/media/sr_ut1.5b429093.png";